var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.privateMessages),function(message){return _c('private-message',{key:message.id,attrs:{"inbox-name":message.inbox_name,"user":message.sender,"message":message.content,"created-at":message.created_at,"attachments":message.attachments}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }